import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CoreService } from "@assoanalytics/app/core/services/core.service";

@Component({
  selector: "app-branding",
  imports: [RouterModule],
  template: `
    <div class="branding d-none d-lg-flex align-items-center">
      <a [routerLink]="['/']" class="d-flex">
        <img src="{{ logo }}" class="" alt="logo" width="{{ logoSize }}" />
      </a>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  logo = this.options.logo;
  logoSize = this.options.logoSize;

  constructor(private settings: CoreService) {}
}
